module.exports = __webpack_public_path__ + "static/media/cnito_live_bg_mobile.4b83f408.svg";